<template>
    <div class="general">
        <div class="general-width">
            <GeneralHeader type="CSV" :title="'Files'" />
            <CSVList></CSVList>
        </div>
    </div>

</template>

<script setup>
import GeneralHeader from '@/components/admin/layouts/GeneralHeaderCard';
import { storeToRefs } from 'pinia';
import { useCsvStore } from '@/store/csvStore';
import { onMounted } from 'vue';
import CSVList from '@/components/admin/csv/CSVList.vue';


const csvStore = useCsvStore();

onMounted(() => {
    csvStore.fetchFiles();
})
</script>